import { ActionHandler } from '@ligo/shared/utils';

export type AuthResources = {
  ME: string;
  REGISTER: string;
  LOGOUT: string;
  LOGIN: string;
  CONFIRMATION: string;
  RESET_PASSWORD: string;
  PASSWORD_CONFIRM: string;
};

export interface DefaultUserInfo {
  data: {
    email: string;
    firstname: string;
    lastname: string;
  };
}

export interface AuthError {
  code: string;
  message: string;
  data: any;
}

export interface DefaultUser {
  id: string;
  uuid: string;
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
  password?: string;
  password_confirmation?: string;
  street?: string;
  house_number?: string;
  zip?: string;
  locale?: string;
  free_months?: number;
  membership?: Membership;
  active_subscription?: Subscription;
  did_receive_contract_for_free: boolean;
  pending_banking_requests: number;
  confirmed_at: string;
  downgrade_date?: string;
  user_hash?: string;
}

export interface Membership {
  from: string;
  id: number;
  membership_type: MembershipType;
  to: string;
  price: string;
  uuid: string;
  available_signatures: number;
  available_templates: number;
  next_billing_date?: string;
}

export interface MembershipType {
  billing_interval: string;
  billing_period: string;
  id: number;
  level: MembershipTypeLevel;
  name: string;
  price: number;
  slug: string;
  uuid: string;
  signatures: number;
  templates: number;
  description: any;
}

export interface Subscription {
  uuid: string;
  from_date: string;
  to_date: string;
  expiration_date: string;
  subscription_type: SubscriptionType;
  payments?: Payment[];
  signature_usage: FeatureUsage;
  template_usage: FeatureUsage;
  next_payment_date?: string;
  free: boolean;
}

export interface Payment {
  uuid: string;
  payable_name: string;
  payable_price: number;
  payment_amount: number;
  paymentAmount: number;
  payment_description: string;
  origin_url?: string;
  payment_link?: string;
}

export interface FeatureUsage {
  amount: number;
  consumed: number;
  uuid: string;
  min: number;
  max: number;
}

export interface SubscriptionType {
  billing_interval: string;
  id: number;
  name: string;
  price: number;
  uuid: string;
  signatures: number;
  templates: number;
  description: any;
  free: number;
  slug: string;
  billing_period: string;
}

export enum MembershipTypeLevel {
  FREE = 'free',
  TRIAL = 'trial',
  BASIC = 'basic',
  PREMIUM = 'premium',
  ACCOUNTANT = 'accountant',
  FEATURES = 'features',
  NOTARY = 'notary'
}

export interface AuthActionHandlers {
  onLogout?: ActionHandler;
  onAuth?: ActionHandler;
}

export interface SocialBtn {
  icon: string;
  label: string;
  provider: string;
}

export interface LoginTexts {
  userPlaceholder: string;
  userLabel: string;
  passPlaceholder: string;
  passLabel: string;
}

export interface ResetTexts {
  userPlaceholder?: string;
  userLabel?: string;
  passPlaceholder?: string;
  passLabel?: string;
  confirmPlaceholder?: string;
  confirmLabel?: string;
}
